import React from 'react'

function EditReceiptPayments() {
  return (
    <div>EditReceiptPayments</div>
  )
}

export default EditReceiptPayments